import type { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { createMissionApi, updateMissionStoreStatusApi, updateMissionApi, deleteMissionApi } from '@/api/missionApi'
import type {
  MissionCreateBody,
  MissionCreateResponse,
  MissionStoreStatusVariables,
  UpdateMissionStoreStatusResponse,
  MissionUpdateBody,
  MissionUpdateResponse,
  MissionDeleteResponse
} from '@/api/model/missionType'

export const useCreateMissionMutation = (
  options?: UseMutationOptions<MissionCreateResponse, AxiosError, MissionCreateBody>
) => {
  return useMutation({
    mutationKey: ['createMission'],
    mutationFn: createMissionApi,
    ...options
  })
}

export const useUpdateMissionMutation = (
  options?: UseMutationOptions<MissionUpdateResponse, AxiosError, { mission_id: string; body: MissionUpdateBody }>
) => {
  return useMutation({
    mutationKey: ['updateMission'],
    mutationFn: ({ mission_id, body }: { mission_id: string; body: MissionUpdateBody }) =>
      updateMissionApi(mission_id, body),
    ...options
  })
}

export const useStoreMissionMutation = (
  options?: UseMutationOptions<UpdateMissionStoreStatusResponse, AxiosError, MissionStoreStatusVariables>
) => {
  return useMutation({
    mutationKey: ['storeMission'],
    mutationFn: (variables: MissionStoreStatusVariables) =>
      updateMissionStoreStatusApi(variables.mission_id.toString(), variables.is_stored),
    ...options
  })
}

export const useDeleteMissionMutation = (
  options?: UseMutationOptions<MissionDeleteResponse, AxiosError, { mission_id: string }>
) => {
  return useMutation({
    mutationKey: ['deleteMission'],
    mutationFn: ({ mission_id }: { mission_id: string }) => deleteMissionApi(mission_id),
    ...options
  })
}
